
<template>
  <div class="scan-sign-container">
    <!-- 标题栏 -->
    <div class="header">
      <el-input 
        v-model="transactionNo" 
        clearable 
        :placeholder="$t('mobile.shipment.prompt')"
        @keyup.enter="search"
        ref="searchInput"
      ></el-input>
      <el-button type="primary" class="submit-btn" @click="search">{{$t('query') }}</el-button>
    </div>
    <PullRefresh
        @refresh="handleRefresh"
        @loadmore="handleLoadMore"
        ref="pullRefresh"
    >
      <!-- 签收区块 -->
      <div class="sign-card" v-for="(item, index) in returnList" :key="index">
        <div class="flex flex-row-between flex-item-center">
          <div class="group-title">{{$t("mobile.shipment.info")}}:</div>
          <el-button
              :disabled="item.isSend"
              type="primary"
              size="small"
              @click="inStore(item)"
              class="action-btn"
          >
            <el-icon><Check /></el-icon>
            {{ $t( "mobile.shipment.resion"+item.isSend ) }}
          </el-button>
        </div>

        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.sale") }}</span>
          <span >{{item.salesRecordNumber}}</span>
        </div>
        <div class="form-row">
          <span class="label">SKU:</span>
          <span >{{item.receiveMaterSku}}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.returnList.product")}}:</span>
          <span class="ellipsis">{{item.receiveMaterName}}</span><span>*{{item.quantity}}</span>
        </div>
        <div class="form-row">
          <span class="label">{{$t("mobile.shipment.warehouse")}}:</span>
          <span >{{item.outTime || $t("mobile.shipment.warehouses")}}</span>
        </div>

      </div>
    </PullRefresh>


  </div>
</template>

<script>
import {ElInput,ElButton,ElIcon} from "element-plus";
import PullRefresh from '@/components/PullRefresh.vue'
import {getSendList} from "@/utils/api"
export default {
  name: 'outList',
  components:{
    ElInput,ElButton,PullRefresh,ElIcon
  },
  data() {
    return {
      transactionNo:"",
      page: 1,
      pageSize: 10,
      hasMore: true,
      returnList: [

      ]
    }
  },
  beforeMount() {
    this.loadData()
  },
  mounted() {
    // 页面加载后自动聚焦输入框
    this.$nextTick(() => {
      this.$refs.searchInput.focus()
    })
  },
  methods: {
    search(){
      this.page=1
      this.hasMore = true
      this.returnList = [] // 清空之前的数据
      this.loadData()
    },
    loadData() {
      // API请求
      getSendList({"transactionNo":this.transactionNo,"PageNumber":this.page,"PageSize":this.pageSize}).then(res=>{
        // 如果是第一页，直接替换数据，否则追加数据
        if (this.page === 1) {
          this.returnList = [...res.Data];
        } else {
          this.returnList.push(...res.Data);
        }
        
        // 判断是否还有更多数据
        if(this.returnList.length >= res.Total) {
          this.hasMore = false;
        } else {
          this.hasMore = true;
        }
        
        // 重置PullRefresh组件状态
        this.$nextTick(() => {
          if(this.$refs.pullRefresh) {
            this.$refs.pullRefresh.refresh();
          }
        });
      }).catch(err=>{
        console.log(err);
      });
    },
    inStore(data){
      this.$router.push({
        path: '/outSelect',
        query: {sendSaleNumber:data.sendSaleNumber},
      });
    },
    handleRefresh(done) {
      this.page = 1
      this.hasMore = true
      this.returnList = []
      this.loadData()
      done()
    },
    handleLoadMore(done) {
      if (!this.hasMore) {
        done()
        return
      }
      this.page++
      this.loadData()
      done()
    }
  }
}
</script>

<style scoped>
.scan-sign-container {
  padding: 12px;
  max-width: 100%;
  box-sizing: border-box;
}

.header {
  margin-bottom: 16px;
  text-align: center;
}
.ellipsis {
  white-space: nowrap;  /* 强制文本不换行 */
  overflow: hidden;     /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出时显示省略号 */
  width: 60%;         /* 必须设置宽度 */
  text-align: left;
}
.title {
  font-size: 20px;
  color: #409EFF;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 12px;
  color: #909399;
}

.sign-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #00000014;
}


.group-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.label {
  width: 80px;
  font-size: 14px;
  color: #606266;
  flex-shrink: 0;
}

.submit-btn {
  width: 100%;
  margin-top: 8px;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .form-row {
    align-items: flex-start;
  }
  .label {
    margin-bottom: 4px;
  }
}
</style>
